import React, { useEffect, useState } from 'react';
import { XCircle, RefreshCw } from 'lucide-react';
import './Cancel.css';

function Cancel() {
  const [reason, setReason] = useState('unknown');

  useEffect(() => {
    // Intentar determinar la razón del fallo
    const saved = localStorage.getItem('currentPayment');
    if (saved) {
      try {
        const data = JSON.parse(saved);
        const timeElapsed = Date.now() - (data.timestamp || 0);
        
        if (timeElapsed > 20 * 60 * 1000) {
          setReason('timeout');
          console.log('❌ Pago cancelado: Tiempo excedido (>20 min)');
        } else {
          setReason('error');
          console.log('❌ Pago cancelado: Error o cancelación manual');
        }
      } catch (e) {
        console.error('Error parseando currentPayment:', e);
      }
    }

    // Limpiar localStorage
    localStorage.removeItem('currentPayment');
    localStorage.removeItem('pendingFormData');
    sessionStorage.removeItem('pendingUploadFiles');
    console.log('🧹 localStorage limpiado');
  }, []);

  const messages = {
    'timeout': {
      title: 'Sesión Expirada',
      text: 'El tiempo límite de 20 minutos ha sido superado. Por favor, genera una nueva orden de pago.'
    },
    'error': {
      title: 'Error en el Pago',
      text: 'Se ha detectado un error técnico (pago en moneda/red incorrecta, pago insuficiente o problema de red).'
    },
    'unknown': {
      title: 'Sesión Expirada o Error',
      text: 'Lo sentimos, la sesión ha expirado o se ha detectado un error. Por favor, intenta de nuevo.'
    }
  };

  const currentMessage = messages[reason] || messages['unknown'];

  return (
    <div className="cancel-container">
      <div className="cancel-card">
        <div className="cancel-icon-container">
          <XCircle className="cancel-icon" />
        </div>
        <h1 className="cancel-title">{currentMessage.title}</h1>
        <p className="cancel-text">
          {currentMessage.text}
        </p>
        
        {reason === 'timeout' && (
          <p className="cancel-text" style={{ 
            fontSize: '13px', 
            opacity: 0.7, 
            marginTop: '12px',
            fontStyle: 'italic' 
          }}>
            💡 Consejo: Los pagos en criptomonedas deben completarse dentro del tiempo límite
          </p>
        )}

        <button
          onClick={() => {
            console.log('🔄 Redirigiendo a inicio para reintentar');
            window.location.href = 'https://eludoteca.org';
          }}
          className="cancel-button"
        >
          <RefreshCw className="button-icon" />
          Reintentar
        </button>
      </div>
    </div>
  );
}

export default Cancel;